// "Test üretim (kredisiz)" — a fake talking-avatar job for trying the flow
// without the API or credits: the progress fills for 10 s, then the job
// completes with media the author already has (the avatar's video, the scene's
// narration), so "Sahneye Ekle" runs the real insert. Test jobs (`test: true`)
// are never polled (useTalkingAvatarJob) nor approved (talkingAvatarInsert).

import { upsertTalkingAvatarJob } from "./talkingAvatarJobStore";

export const TEST_RUN_DURATION_MS = 10 * 1000;
const STEPS = 10;
const TEST_HOST_RE = /(^localhost$|^127\.0\.0\.1$|stage|(^|[.-])dev([.-]|$))/i;
const FLAG_KEY = "talkingAvatarTestRun";

/** Shown on localhost / stage / dev hosts, or anywhere with localStorage talkingAvatarTestRun=1. */
export function isTalkingAvatarTestRunEnabled(
  loc = typeof window !== "undefined" ? window.location : null,
  storage = typeof window !== "undefined" ? window.localStorage : null
) {
  try {
    if (storage && storage.getItem(FLAG_KEY) === "1") return true;
  } catch (e) {
    // storage blocked — fall through to the host check
  }
  return !!(loc && TEST_HOST_RE.test(loc.hostname || ""));
}

/**
 * record: what a real submit stores (navId, sceneIndex, model, voice, text, avatar…).
 * media: { videoUrl, audioUrl?, durationSec? } — audio falls back to the video.
 */
export function startTalkingAvatarTestRun(record, { videoUrl, audioUrl, durationSec } = {}) {
  const jobId = `test-${Date.now().toString(36)}${Math.random().toString(36).slice(2, 6)}`;
  upsertTalkingAvatarJob({
    ...record,
    jobId,
    test: true,
    status: "processing",
    progress: 0,
    createdAt: Date.now(),
  });
  const stepMs = TEST_RUN_DURATION_MS / STEPS;
  for (let i = 1; i < STEPS; i += 1) {
    setTimeout(() => upsertTalkingAvatarJob({ jobId, progress: i * (100 / STEPS) }), i * stepMs);
  }
  setTimeout(() => {
    upsertTalkingAvatarJob({
      jobId,
      status: "completed",
      progress: 100,
      result: {
        kind: "talking-avatar",
        videoUrl,
        url: videoUrl,
        audioUrl: audioUrl || videoUrl,
        duration: Number(durationSec) > 0 ? Number(durationSec) : 0,
        warnings: [],
        test: true,
      },
    });
  }, TEST_RUN_DURATION_MS);
  return jobId;
}
